import { CheckListBarData, Modules, Steps } from "../../contracts";
import { ParentContextProps } from "../../store/context";
import { CurrentGuideProgress, OnboardingMaps } from "../../store/reducers";

export interface OnboardingChecklistBarProps {
	readonly parentContext: ParentContextProps | null;
	readonly checkListBarData: CheckListBarData | null;
	readonly moduleOrder: Modules[];
	readonly activeStep: Steps | null;
	readonly onboardingMaps: OnboardingMaps | null;
	readonly quitOnboarding: () => Promise<void>;
	readonly updateActiveModuleOnClick: (
		moduleIndex: number,
		nextSteps: CurrentGuideProgress
	) => Promise<void>;
	readonly skipModule: () => Promise<void>;
	readonly updateRevisitModule: (revisitModuleIndex: number) => Promise<void>;
	readonly activeModule: Modules | null;
	readonly hideCheckList: boolean;
}

export enum CheckListBarMoreOptions {
	HELP_CENTRE = "help_centre",
	SKIP_MODULE = "skip_module",
	QUIT_TUTORIAL = "quit_tutorial"
}

export const MainModulesIds = ["main_0", "main_1", "main_2"];
